import { onBeforeUnmount, onMounted, ref, type Ref } from 'vue'

/** `true` below the 1024 desktop breakpoint (DS `Size=Mobile`). */
export function useFairCompact(): Ref<boolean> {
  const compact = ref(false)
  let query: MediaQueryList | null = null
  const sync = () => {
    compact.value = query?.matches ?? false
  }

  onMounted(() => {
    query = window.matchMedia('(max-width: 1023px)')
    sync()
    query.addEventListener('change', sync)
  })

  onBeforeUnmount(() => {
    query?.removeEventListener('change', sync)
  })

  return compact
}
